import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from '@angular/router';
import { UserRouteAccessCrudService } from '../../shared';
// import { JhiPaginationUtil } from 'ng-jhipster';
import { ItemEditComponent } from './item-edit.component';

import {CONFIG} from './../../shared/constants/config.constants';

@Injectable()
export class ItemResolvePagingParams implements Resolve<any> {

    constructor() {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        const sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,desc';
        return {
            // page: this.paginationUtil.parsePage(page),
            // predicate: this.paginationUtil.parsePredicate(sort),
            // ascending: this.paginationUtil.parseAscending(sort)
      };
    }
}

export const clientManagementRoute: Routes = [
    {
        path: 'client-management/new/edit',
        component: ItemEditComponent,
        data: {
            authorities: ['ROLE_ADMIN'],
            pageTitle: 'clientManagement.title',
            permissions: [CONFIG.permissions.clientManagement.C]
        },
        canActivate: [UserRouteAccessCrudService],
    }, {
        path: 'client-management/:id/edit',
        component: ItemEditComponent,
        data: {
            authorities: ['ROLE_ADMIN'],
            pageTitle: 'clientManagement.title',
            permissions: [CONFIG.permissions.clientManagement.U]
        },
        canActivate: [UserRouteAccessCrudService],
    },
];
